// extracted by css-extract-rspack-plugin
export default {"tooltipParent":"EpCmTHzkZEYuvn9H","tooltipContent":"kc8mb8lhxuoX5RKJ"};